import React from 'react'

import {createLargeSvgIcon} from './utils'

export default createLargeSvgIcon(
  <>
    <g clipPath="url(#clip0)">
      <path
        d="M0 19.2C0 12.4794 0 9.11905 1.30792 6.55211C2.4584 4.29417 4.29417 2.4584 6.55211 1.30792C9.11905 0 12.4794 0 19.2 0H20.8C27.5206 0 30.8809 0 33.4479 1.30792C35.7058 2.4584 37.5416 4.29417 38.6921 6.55211C40 9.11905 40 12.4794 40 19.2V20.8C40 27.5206 40 30.8809 38.6921 33.4479C37.5416 35.7058 35.7058 37.5416 33.4479 38.6921C30.8809 40 27.5206 40 20.8 40H19.2C12.4794 40 9.11905 40 6.55211 38.6921C4.29417 37.5416 2.4584 35.7058 1.30792 33.4479C0 30.8809 0 27.5206 0 20.8V19.2Z"
        fill="#FCDA30"
      />
      <path
        d="M9.87248 9.73678L-8.25265 33.5071L-3.38486 39.0782L10.1718 21.2096L8.81903 30.976L16.4135 33.5671L25.4551 18.8149C25.0165 21.607 24.2915 27.9291 30.45 29.796C39.9549 32.6775 48.2218 15.6308 52.1075 6.93105L46.6271 4.03338C42.3972 12.948 35.736 22.917 33.1374 22.1925C30.5522 21.4718 32.8906 13.1145 34.3986 7.72479L34.4221 7.64089L26.0189 4.79424L16.0116 21.2151L17.3636 12.3278L9.87248 9.73678Z"
        fill="#3D3C37"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <path
          d="M0 19.2C0 12.4794 0 9.11905 1.30792 6.55211C2.4584 4.29417 4.29417 2.4584 6.55211 1.30792C9.11905 0 12.4794 0 19.2 0H20.8C27.5206 0 30.8809 0 33.4479 1.30792C35.7058 2.4584 37.5416 4.29417 38.6921 6.55211C40 9.11905 40 12.4794 40 19.2V20.8C40 27.5206 40 30.8809 38.6921 33.4479C37.5416 35.7058 35.7058 37.5416 33.4479 38.6921C30.8809 40 27.5206 40 20.8 40H19.2C12.4794 40 9.11905 40 6.55211 38.6921C4.29417 37.5416 2.4584 35.7058 1.30792 33.4479C0 30.8809 0 27.5206 0 20.8V19.2Z"
          fill="white"
        />
      </clipPath>
    </defs>
  </>,
  'Market',
)
